import React from "react";
import { useCurrency } from "contexts/CurrencyContext";

export interface PriceProps {
  price: number | string;
  originalPrice?: number | string;
  currency?: string;
  className?: string;
  badgeClass?: string;
  contentClass?: string;
  isRobotics?: boolean;
}

const Prices: React.FC<PriceProps> = ({
  price,
  originalPrice,
  currency: propCurrency,
  className = "",
  badgeClass,
  contentClass = "py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium",
  isRobotics = false,
}) => {
  const { currency, format } = useCurrency();

  if (isRobotics) {
    return (
      <div className={`flex min-w-0 items-center ${className}`}>
        <span
          className={`inline-flex items-center whitespace-nowrap rounded-lg border-2 border-green-500 ${badgeClass ?? contentClass} text-green-700 dark:text-green-300 hover:bg-green-50 dark:hover:bg-neutral-700 transition-colors`}
        >
          Price upon request
        </span>
      </div>
    );
  }

  const rawPrice = Number(price ?? 0);
  const validPrice = Number.isFinite(rawPrice);
  const formattedPrice = validPrice ? format(rawPrice, { currency: propCurrency || currency }) : "N/A";

  const rawOriginalPrice = originalPrice ? Number(originalPrice) : undefined;
  const validOriginalPrice = rawOriginalPrice && Number.isFinite(rawOriginalPrice);
  const formattedOriginalPrice = validOriginalPrice ? format(rawOriginalPrice, { currency: propCurrency || currency }) : null;

  return (
    <div className={`flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 ${className}`}>
      <span
        className={`inline-flex max-w-full items-center whitespace-nowrap rounded-lg border-2 border-green-500 ${badgeClass ?? contentClass} text-green-700 dark:text-green-300 hover:bg-green-50 dark:hover:bg-neutral-700 transition-colors`}
      >
        {formattedPrice}
      </span>
      {formattedOriginalPrice && (
        <span className="shrink-0 text-sm text-gray-500 dark:text-gray-400 line-through">
          {formattedOriginalPrice}
        </span>
      )}
    </div>
  );
};

export default Prices;
